// extracted by css-extract-rspack-plugin
export default {"cls1":"KiiTypeahead-cls1_O8r","cls2":"KiiTypeahead-cls2_vbn KiiTypeahead-cls1_O8r"};